import React from 'react';

function FileEarmarkText() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="#6C757D"
        d="M4.5 1.125h5.625V2.25H4.5a1.125 1.125 0 00-1.125 1.125v11.25A1.125 1.125 0 004.5 15.75h9a1.125 1.125 0 001.125-1.125V6.75h1.125v7.875a2.25 2.25 0 01-2.25 2.25h-9a2.25 2.25 0 01-2.25-2.25V3.375a2.25 2.25 0 012.25-2.25z"
      ></path>
      <path
        fill="#6C757D"
        d="M10.125 5.063V1.124L15.75 6.75h-3.938a1.687 1.687 0 01-1.687-1.688z"
      ></path>
      <path
        fill="#6C757D"
        fillRule="evenodd"
        d="M5.625 12.938a.562.562 0 01.563-.563h2.25a.563.563 0 010 1.125h-2.25a.563.563 0 01-.563-.563zm0-2.25a.562.562 0 01.563-.563h5.625a.562.562 0 110 1.125H6.186a.563.563 0 01-.562-.563zm0-2.25a.563.563 0 01.563-.563h5.625a.562.562 0 110 1.125H6.186a.563.563 0 01-.562-.563z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default FileEarmarkText;
